import { GetterTree, ActionTree } from 'vuex';
import { PersistentStore, saveAndSync, syncOperation } from '@/utils/PersistentStore';
import { replaceInArray } from '@/utils/Array';
import vuestore, { store } from '@/store';
import { CreateTypedStoreProxy } from 'vuex-typed-store';
import { areaSaggioClasseDiametricaService } from '../services/areaSaggioClasseDiametricaService';
import { versioneInSituStore } from '@/modules/VersioneInSitu/store/VersioneInSitu.store';
import { Guid } from 'guid-typescript';
import { syncDeletedRow } from '@/modules/SyncDeletedRow/helper/syncDeletedRowHelper';

export interface AreaSaggioClasseDiametricaStoreModel { }

export interface AreaSaggioClasseDiametricaStoreActions {
  setAreaSaggioClasseDiametrica(payload: server.areaSaggioClasseDiametrica): Promise<void>;
  remove(payload: server.areaSaggioClasseDiametrica): Promise<void>;
  removeAll(payload: { areaSaggioId: string, versioneId: string }): Promise<void>;
  clean(): Promise<void>;
}

export interface AreaSaggioClasseDiametricaStoreGetters {
  get(id): Promise<server.areaSaggioClasseDiametrica>;
  getAll(): Promise<server.areaSaggioClasseDiametrica[]>;
  requiredSync(specieArboreaId: number): Promise<boolean>;
}

interface areaSaggioClasseDiametricaNeedSync extends server.areaSaggioClasseDiametrica {
  __needsSync: boolean
}

export const TABLES = { areaSaggioClasseDiametrica: 'AreeSaggioClassiDiametriche' };
export const AreaSaggioClasseDiametricaStore = {
  PREFIX: 'areaSaggioClasseDiametrica',
  namespaced: true,
  mutations: {},
  getters: {
    get: (state) => async (id): Promise<server.areaSaggioClasseDiametrica> => await PersistentStore.get(TABLES.areaSaggioClasseDiametrica, id),
    getAll: (state) => async (): Promise<server.areaSaggioClasseDiametrica[]> => {
      let currentVersion = await versioneInSituStore.getters.current();
      if (!currentVersion) return [];

      var result = await PersistentStore.getAll<server.areaSaggioClasseDiametrica>(TABLES.areaSaggioClasseDiametrica) || [];

      if (result.length > 0) {
        result = await syncDeletedRow(TABLES.areaSaggioClasseDiametrica, result);
      }

      var maxts = await PersistentStore.getMaxTs(TABLES.areaSaggioClasseDiametrica);
      areaSaggioClasseDiametricaService.List(currentVersion.id, maxts).then(async (r) => {
        replaceInArray(r, result, (a, b) => a.id == b.id);
        await PersistentStore.set(TABLES.areaSaggioClasseDiametrica, r);
      });
      return result;
    },
    requiredSync: (state) => async (specieArboreaId?: number): Promise<boolean> => {
      var result = await PersistentStore.getAll<server.areaSaggioClasseDiametrica>(TABLES.areaSaggioClasseDiametrica) || [];
      return result.filter(f => (!specieArboreaId || specieArboreaId === f.specie)).some((s: areaSaggioClasseDiametricaNeedSync) => s.__needsSync === true && !s.timeStamp);
    }
  } as GetterTree<AreaSaggioClasseDiametricaStoreModel, AreaSaggioClasseDiametricaStoreGetters>,

  actions: {
    async setAreaSaggioClasseDiametrica(context, payload: server.areaSaggioClasseDiametrica) {

      let operation: syncOperation = syncOperation.update;
      if (!payload.id) {
        payload.id = Guid.create().toString();
        operation = syncOperation.create;
      }

      await saveAndSync(payload, TABLES.areaSaggioClasseDiametrica,
        i => operation, i => areaSaggioClasseDiametricaService.Set(i, i.versioneId), i => areaSaggioClasseDiametricaService.Set(i, i.versioneId),
        async (o, n, op) => { })
    },
    async remove(context, payload: server.areaSaggioClasseDiametrica) {
      const entity: areaSaggioClasseDiametricaNeedSync = await PersistentStore.get(TABLES.areaSaggioClasseDiametrica, payload.id);
      if (entity.timeStamp) {
        await areaSaggioClasseDiametricaService.Remove(payload.id, payload.versioneId);
      }
      await PersistentStore.remove(TABLES.areaSaggioClasseDiametrica, payload);
    },
    async removeAll(context, payload: { areaSaggioId: string, versioneId: string }) {
      if (payload.versioneId && payload.areaSaggioId) {
        var result = await PersistentStore.getAll<server.areaSaggioClasseDiametrica>(TABLES.areaSaggioClasseDiametrica) || [];
        if (result.length > 0) {
          const toRemove = result.filter(f => f.versioneId === payload.versioneId && f.areaSaggioId === payload.areaSaggioId);
          return Promise.all(toRemove.map(async (f) => await areaSaggioClasseDiametricaStore.actions.remove(f)));
        }
      }
      return;
    },
    async clean(context) {
      var result = await PersistentStore.getAll<server.areaSaggioClasseDiametrica>(TABLES.areaSaggioClasseDiametrica) || [];
      if (result.length > 0) {
        return Promise.all(result.map(async (f) => PersistentStore.remove(TABLES.areaSaggioClasseDiametrica, f)));
      }
    }
  } as ActionTree<AreaSaggioClasseDiametricaStoreModel, AreaSaggioClasseDiametricaStoreActions>
}

export const areaSaggioClasseDiametricaStore = CreateTypedStoreProxy<AreaSaggioClasseDiametricaStoreModel, AreaSaggioClasseDiametricaStoreActions, AreaSaggioClasseDiametricaStoreGetters>(vuestore, AreaSaggioClasseDiametricaStore.PREFIX);